import React from 'react';
import './STSNetwork.css';

function STSNetwork() {
  return (
    <div className='Sts_Network'>
      <div className='Sts_Main'>
        <h3>STS NETWORK</h3>
      </div>
      <div className='Sts_Cont'>
      <div className='sts_main2'>
        <h2>Test Centers</h2>
        <h1>40+</h1>
      </div>
      <div className='sts_main2'>
        <h2>Supervisers</h2>
        <h1>350+</h1>
      </div>
      <div className='sts_main2'>
        <h2>Invigilators</h2>
        <h1>2500+</h1>
      </div>
      <div className='sts_main2'>
        <h2>District Managers</h2>
        <h1>50+</h1>
      </div>
    </div>
    </div>
  )
}

export default STSNetwork
